module.exports = __webpack_public_path__ + "static/media/mt-ut-img-3-2.a846bb64.jpg";